import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { MUTUAL_FUNDS_VENUE_ORDER_BASE_PATH } from '../../../../../../../../../features/mutual-funds/venue-order/mutual-funds-venue-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'mutual-funds-venue-order-list',
        label: 'Mutual Funds',
        to: MUTUAL_FUNDS_VENUE_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
